module.exports = __webpack_public_path__ + "static/img/Bachelor_010662.2fece5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010662.jpg
// module id = 207
// module chunks = 0